import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { ComponentsModule } from '../../components/components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';



@NgModule({
  declarations: [AccountComponent],
  imports: [
    CommonModule, ComponentsModule, ReactiveFormsModule, DropdownModule, InputTextModule, ButtonModule, TagModule, TableModule, TranslateModule, MessageModule
  ]
})
export class AccountModule { }
